/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterDados() {
        return axiosJwt.get(`${api}/fornecedor/dadoscadastrais`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDadosPorCpfCnpj(cpfCnpj) {
        return axiosJwt.get(`${api}/fornecedores/cpfcnpj/${cpfCnpj}/dadoscadastrais`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/fornecedor/dadoscadastrais/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(dadosCadastrais) {
        return axiosJwt.post(`${api}/fornecedor/dadoscadastrais/atualizar`, dadosCadastrais)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
